import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useState } from "preact/hooks";
import { createOrderRevision } from "../../../api/product-api";
import { route } from "../../../App";
import { OrderComposer } from "../../../components/OrderComposer";
import "./styles.scss";

export function OrderRevision(props: RoutableProps & { id?: string }) {
    const [createdOrderId, setCreatedOrderId] = useState(0);

    const orderId = props.id ? parseInt(props.id) : NaN;

    return <div class="order-revision-page">
        {!createdOrderId ? [
            <div class="order paper">
                <h1>Tworzenie nowej rewizji zestawienia</h1>
                <OrderComposer id={orderId} edit={true} orderTypes={[]} serialRegexes={[]} commitTitle="Utwórz rewizję" onCommit={async (orderName, description, elementList, otherData) => {
                    const data = await createOrderRevision(orderId, description, elementList, otherData);
                    setCreatedOrderId(orderId);
                }}/>
            </div>
        ] : [
            <div class="ready">
                Nowa rewizja dla zestawienia została dodana
            </div>,
            <div class="ready-options">
                <button type="button" onClick={() => route(`/order/${createdOrderId}`, true)}>Podgląd zestawienia</button>
                <button type="button" class="secondary" onClick={() => history.back()}>Powrót</button>
            </div>
        ]}
    </div>;
}
